
import { defineComponent, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';

export default defineComponent({
  emits: ['close'],
  setup(props, { emit }) {
    const modal = ref();

    function close() {
      emit('close');
    }

    onClickOutside(modal, close);

    return {
      modal,
    };
  },
});
